import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';
import { ModalService } from '@shared/components/modal-list/modal-list.service';
import { ConfirmCodeComponent } from '@b2b/features/forgot-password-dialog/components/confirm-code/confirm-code.component';
import { NewPasswordComponent } from '@b2b/features/forgot-password-dialog/components/new-password/new-password.component';
import { ReceiveCodeComponent } from '@b2b/features/forgot-password-dialog/components/receive-code/receive-code.component';
import { ForgotPasswordService } from '@b2b/features/forgot-password-dialog/core/forgot-password.service';
import { ChangePasswordOptions } from '@b2b/features/forgot-password-dialog/core/forgot-password.types';

@Component({
  selector: 'forgot-password-dialog',
  imports: [CommonModule, ReceiveCodeComponent, ConfirmCodeComponent, NewPasswordComponent],
  templateUrl: './forgot-password-dialog.component.html',
  styleUrl: './forgot-password-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordDialogComponent implements OnInit, OnDestroy {
  currentStep$ = this.forgotPasswordService.currentStep$;

  user$ = this.modalService.getActiveModal().pipe(map(modal => modal?.data?.user));

  constructor(
    private forgotPasswordService: ForgotPasswordService,
    private modalService: ModalService<ChangePasswordOptions>,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.currentStep$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter(step => step === 'SUCCESS'),
      )
      .subscribe(() => {
        this.modalService.close();
      });
  }

  ngOnDestroy(): void {
    this.forgotPasswordService.reset();
  }
}
